module.exports = __webpack_public_path__ + "static/media/Box-with-shield.073d669b.png";